import BorderBeam from './BorderBeam';

export default BorderBeam;
